<ng-container *transloco="let t; read: 'action-plan-details-items-tab'">
  <div class="action-plan-details-items-tab__container">
    <div class="action-plan-details-items-tab__header">
      <span class="action-plan-details-items-tab__title">{{
        t('title', {
          breakdown: actionPlan.metadata.breakdown,
          metric: actionPlan.metric_name,
        })
      }}</span>

      <div class="action-plan-details-items-tab__header-actions">
        <div
          [matBadge]="hasActiveFilter ? '1' : ''"
          class="action-plan-details-items-tab__filter-icon-wrapper"
        >
          <xi-icon-button icon="filter" color="CX" (onClick)="onOpenFilterModal()">
          </xi-icon-button>
        </div>

        <xi-icon-button icon="kabob" color="CX" [disabled]="true"> </xi-icon-button>
      </div>
    </div>

    <div class="action-plan-details-items-tab__actions">
      <xi-search-box
        [placeholder]="t('searchbox')"
        [value]="searchValue"
        (keyup)="onSearch($event.target.value)"
        (onCancelClick)="onSearch('')"
        class="action-plan-details-items-tab__search-box"
      ></xi-search-box>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      matSort
      [matSortActive]="sort.active"
      [matSortDirection]="sort.direction"
      matSortDisableClear
      (matSortChange)="onSortChange($event)"
      class="action-plan-details-items-tab__table"
    >
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef>
          <mat-icon
            class="action-plan-details-items-tab__expand-icon pointer"
            (click)="onToggleAllRow()"
            [ngClass]="
              isAllRowExpanded
                ? 'action-plan-details-items-tab__expand-icon--open'
                : 'action-plan-details-items-tab__expand-icon--closed'
            "
            >expand_more</mat-icon
          >
        </th>
        <td mat-cell *matCellDef="let item">
          <mat-icon
            class="action-plan-details-items-tab__expand-icon pointer"
            (click)="onToggleRow(item)"
            [ngClass]="
              item.isExpanded
                ? 'action-plan-details-items-tab__expand-icon--open'
                : 'action-plan-details-items-tab__expand-icon--closed'
            "
            >expand_more</mat-icon
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ t('action-item') }}
        </th>
        <td
          mat-cell
          *matCellDef="let item"
          class="action-plan-details-items-tab__name-cell action-plan-details-items-tab__truncate-cell"
          [matTooltip]="item.name"
          appShowMatTooltipIfTruncated
        >
          {{ item.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="due_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ t('due-date') }}
        </th>
        <td
          mat-cell
          *matCellDef="let item"
          [ngClass]="item.isExpired ? 'action-plan-expired' : ''"
          [matTooltip]="item.expiredTooltip"
        >
          {{ item.dueDate | date: 'dd-MM-yyyy' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ t('status') }}
        </th>
        <td mat-cell *matCellDef="let item">
          <app-status-label
            [status]="item.status"
            [isFixed]="isReadOnly"
            (statusChange)="onItemStatusChange($event, item)"
          ></app-status-label>
        </td>
      </ng-container>

      <ng-container matColumnDef="assignee">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ t('assignee') }}
        </th>
        <td
          mat-cell
          *matCellDef="let item"
          class="action-plan-details-items-tab__truncate-cell"
          [matTooltip]="item.assignee"
          appShowMatTooltipIfTruncated
        >
          {{ item.assignee }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <div
            [matMenuTriggerFor]="!isReadOnly ? itemActionsMenu : null"
            (menuOpened)="onOpenItemActionsMenu(item)"
          >
            <xi-icon-button
              color="CX"
              buttonSize="small"
              icon="kabob"
              [disabled]="isReadOnly"
            ></xi-icon-button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="detail">
        <td mat-cell *matCellDef="let item" [attr.colspan]="displayedColumns.length">
          <div class="action-plan-details-items-tab__detail-container">
            <div class="action-plan-details-items-tab__detail-notes-container">
              <span class="action-plan-details-items-tab__detail-notes">{{ item.notes }}</span>

              <!-- just for fill other columns empty space -->
              <div></div>
            </div>

            <span class="action-plan-details-items-tab__tasks-header"
              >{{ t('tasks') }} ({{ item.tasks.length }})</span
            >

            @if (item.tasks?.length > 0) {
              <table
                mat-table
                [dataSource]="item.tasks"
                class="action-plan-details-items-tab__task-table"
              >
                <ng-container matColumnDef="icon">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef>
                    <mat-icon class="action-plan-details-items-tab__task-arrow-icon"
                      >subdirectory_arrow_right</mat-icon
                    >
                  </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td
                    mat-cell
                    *matCellDef="let task"
                    class="action-plan-details-items-tab__name-cell action-plan-details-items-tab__truncate-cell"
                    [matTooltip]="task.name"
                    appShowMatTooltipIfTruncated
                  >
                    {{ task.name }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="due_date">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td
                    mat-cell
                    *matCellDef="let task"
                    [ngClass]="task.isExpired ? 'action-plan-expired' : ''"
                    [matTooltip]="task.expiredTooltip"
                  >
                    {{ task.dueDate | date: 'dd-MM-yyyy' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let task">
                    <app-status-label
                      [status]="task.status"
                      [isFixed]="isReadOnly"
                      (statusChange)="onTaskStatusChange($event, item.id, task)"
                    ></app-status-label>
                  </td>
                </ng-container>
                <ng-container matColumnDef="assignee">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td
                    mat-cell
                    *matCellDef="let task"
                    class="action-plan-details-items-tab__truncate-cell"
                    [matTooltip]="task.assignee"
                    appShowMatTooltipIfTruncated
                  >
                    {{ task.assignee }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let task">
                    <div
                      [matMenuTriggerFor]="!isReadOnly ? taskActionsMenu : null"
                      (menuOpened)="onOpenTaskActionsMenu(item, task)"
                    >
                      <xi-icon-button
                        color="CX"
                        buttonSize="small"
                        icon="kabob"
                        [disabled]="isReadOnly"
                      ></xi-icon-button>
                    </div>
                  </td>
                </ng-container>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="action-plan-details-items-tab__main-row"
        [ngClass]="
          row.isExpanded
            ? 'action-plan-details-items-tab__main-row--expanded'
            : 'action-plan-details-items-tab__main-row--collapsed'
        "
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['detail']"
        class="action-plan-details-items-tab__detail-row"
        [ngClass]="
          row.isExpanded
            ? 'action-plan-details-items-tab__detail-row--expanded'
            : 'action-plan-details-items-tab__detail-row--collapsed'
        "
      ></tr>
    </table>
  </div>

  <mat-menu #itemActionsMenu>
    <ng-template matMenuContent>
      <button mat-menu-item (click)="onAddTask()">
        {{ t('add-task') }}
      </button>
      <button mat-menu-item (click)="onEditItem()">
        {{ t('edit-action-item') }}
      </button>
      <button mat-menu-item (click)="onDeleteItem()">
        {{ t('delete-action-item') }}
      </button>
    </ng-template>
  </mat-menu>

  <mat-menu #taskActionsMenu>
    <ng-template matMenuContent>
      <button mat-menu-item (click)="onEditTask()">
        {{ t('edit-task') }}
      </button>
      <button mat-menu-item (click)="onDeleteTask()">
        {{ t('delete-task') }}
      </button>
    </ng-template>
  </mat-menu>
</ng-container>

@if (isFilterModalOpen) {
  <app-lex-xi-modal
    [isVisible]="isFilterModalOpen"
    (close)="onCloseFilterModal(null)"
    maxWidth="400px"
  >
    <ng-template appXIModalContent>
      @if (isFilterModalOpen) {
        <app-action-item-list-filter
          [filter]="filter"
          (modalClose)="onCloseFilterModal($event)"
        ></app-action-item-list-filter>
      }
    </ng-template>
  </app-lex-xi-modal>
}

<app-lex-xi-modal
  [isVisible]="isActionItemDialogOpen"
  (close)="onCloseActionItemDialog()"
  maxWidth="800px"
>
  <ng-template appXIModalContent>
    @if (isActionItemDialogOpen) {
      <app-create-action-item-dialog
        [actionPlanInfo]="actionPlanInfo"
        [actionItem]="actionItemToDialog"
        [fromDashboard]="false"
        (update)="onUpdateActionItem($event)"
        (modalClosed)="onCloseActionItemDialog()"
      ></app-create-action-item-dialog>
    }
  </ng-template>
</app-lex-xi-modal>

<app-lex-xi-modal
  [isVisible]="isActionTaskDialogOpen"
  (close)="onCloseActionTaskDialog()"
  maxWidth="800px"
>
  <ng-template appXIModalContent>
    @if (isActionTaskDialogOpen) {
      <app-create-action-task-dialog
        [actionPlan]="actionPlan"
        [actionItem]="actionItemToDialog"
        [actionTask]="actionTaskToDialog"
        [fromDashboard]="false"
        (create)="onCreateActionTask($event)"
        (update)="onUpdateActionTask($event)"
        (modalClosed)="onCloseActionTaskDialog()"
      ></app-create-action-task-dialog>
    }
  </ng-template>
</app-lex-xi-modal>
